import React from 'react';

import { downloadSource } from 'Helpers/urlService';

import DownloadIcon from 'Assets/icons/download.svg';

/**
 * The order's attachments, downloaded through the approver's own route so an
 * approver without the Procurement module can still read the quote.
 */
export default function CommitmentAttachments({ orderId, attachments, downloadUrl }) {
    const download = (attachment) => downloadSource(attachment.name, downloadUrl.replace('ORDER_ID', orderId).replace('ATTACHMENT_ID', attachment.id));

    return (
        <div>
            <div className="bc-eyebrow">{$t('Attachments')}</div>
            {attachments.length === 0 ? (
                <div className="bc-sub tw-text-[13px]">{$t('No attachments')}</div>
            ) : (
                <div className="tw-flex tw-flex-wrap tw-gap-2">
                    {attachments.map((attachment) => (
                        <button
                            type="button"
                            key={attachment.id}
                            onClick={() => download(attachment)}
                            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-white tw-px-3 tw-py-1.5 tw-text-[13px] tw-font-medium tw-text-charcoal hover:tw-border-blue"
                        >
                            <DownloadIcon className="tw-h-3.5 tw-w-3.5 tw-text-blue" aria-hidden="true" />
                            {attachment.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
